import {
    yearColor,
    districtColor,
    lineAndTextColor,
    backgroundColor,
    fieldSpotsPerYearChartTitle,
    fieldSpotsPerDistrictChartTitle,
    lastFieldSpotsChartTitle,
    getDistrictAbbreviation,
} from "./DataVisualizationsConfig"

export function buildFieldSpotsPerYearSeries(fieldSpotsPerYear) {
    let series = [];

    let counter = 0;
    const dataDictLenght = Object.keys(fieldSpotsPerYear).length;
    Object.entries(fieldSpotsPerYear).forEach(([year, spots]) => {
        series.push({
            name: year,
            type: "scatter",
            color: yearColor[year],
            data: setYaxisForSwarmPlot(spots, dataDictLenght - counter),
        });
        counter++;
    });
    return series;
}

export function buildFieldSpotsPerDistrictSeries(fieldSpots) {

    const series = [];

    //Object.keys(fieldSpots).forEach(year => {
    //const fieldSpotsPerDistrict = fieldSpots[year];

    let counter = 0;
    const dataDictLenght = Object.keys(fieldSpots).length;
    Object.entries(fieldSpots).forEach(([district, spots]) => {
        series.push({
            name: district,
            type: "scatter",
            color: districtColor[district],
            data: setYaxisForSwarmPlot(spots, dataDictLenght - counter),
        });
        counter++;

    });

    // })

    return series;

}

export function buildFieldSpotsInDistrictSeries(fieldSpots) {

    const series = [];

    let counter = 0;
    const dataDictLenght = Object.keys(fieldSpots).length;
    Object.entries(fieldSpots).forEach(([year, spots]) => {
        series.push({
            name: year,
            type: "scatter",
            color: yearColor[year],
            data: setYaxisForSwarmPlot(spots, dataDictLenght - counter),
        });
        counter++;
    });

    return series;

}

export function buildFieldSpotsPerYearConfig(series, fieldSpotsPerYear, selectedField) {
    const categories = getYears(fieldSpotsPerYear);
    const jitter =
        selectedField === "Medicina Geral e Familiar" ? 0.2 : 0.05;
    return {
        title: {
            text: `${fieldSpotsPerYearChartTitle} de ${selectedField}`,
            style: {
                color: lineAndTextColor,
            },
        },
        chart: {
            backgroundColor: backgroundColor,
            style: {
                color: lineAndTextColor,
            },
        },
        legend: {
            itemStyle: {
                color: lineAndTextColor,
            },
        },
        plotOptions: {
            scatter: {
                jitter: {
                    x: 0,
                    y: jitter,
                },
                marker: {
                    radius: 3,
                    symbol: "circle",
                },
                tooltip: {
                    pointFormat: "Posição: {point.x} <br> Instituição: {point.institution}",
                },
            },

            series: {
                events: {
                    legendItemClick: function (event) {
                        toggleSeriesVisibility(this);
                        return false;
                    },
                },
            },
        },
        yAxis: {
            categories: categories,
            title: {
                enabled: false,
            },
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
            gridLineColor: "transparent",
        },
        xAxis: {
            min: 0,
            lineColor: lineAndTextColor,
            tickColor: lineAndTextColor,
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
        },
        series: series,
    };
}

export function buildFieldSpotsPerDistrictConfig(series, fieldSpots, selectedField, selectedYear) {
    const categories = getDistricts(fieldSpots);
    return {
        title: {
            text: `${fieldSpotsPerDistrictChartTitle} de ${selectedField} em ${selectedYear}`,
            style: {
                color: lineAndTextColor,
            },
        },
        chart: {
            backgroundColor: backgroundColor,
            style: {
                color: lineAndTextColor,
            },
        },
        legend: {
            itemStyle: {
                color: lineAndTextColor,
            },
        },
        plotOptions: {
            scatter: {
                jitter: {
                    x: 0,
                    y: getJitter(selectedField),
                },
                marker: {
                    radius: 3,
                    symbol: "circle",
                },
                tooltip: {
                    pointFormat: "Posição: {point.x} <br> Instituição: {point.institution}",
                },
            },

            series: {
                events: {
                    legendItemClick: function (event) {
                        toggleSeriesVisibility(this);
                        return false;
                    },
                },
            },
        },
        yAxis: {
            categories: categories,
            title: {
                enabled: false,
            },
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
            gridLineColor: "transparent",
        },
        xAxis: {
            min: 0,
            lineColor: lineAndTextColor,
            tickColor: lineAndTextColor,
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
        },
        series: series,
    };

}

export function buildFieldSpotsInDistrictConfig(series, fieldSpots, selectedField, selectedDistrict) {
    const categories = getYears(fieldSpots);
    return {
        title: {
            text: `${fieldSpotsPerYearChartTitle} de ${selectedField} ${getDistrictPreposition(selectedDistrict)} ${selectedDistrict}`,
            style: {
                color: lineAndTextColor,
            },
        },
        chart: {
            backgroundColor: backgroundColor,
            style: {
                color: lineAndTextColor,
            },
        },
        legend: {
            itemStyle: {
                color: lineAndTextColor,
            },
        },
        plotOptions: {
            scatter: {
                jitter: {
                    x: 0,
                    y: getJitter(selectedField),
                },
                marker: {
                    radius: 3,
                    symbol: "circle",
                },
                tooltip: {
                    pointFormat: "Posição: {point.x} <br> Instituição: {point.institution}",
                },
            },

            series: {
                events: {
                    legendItemClick: function (event) {
                        toggleSeriesVisibility(this);
                        return false;
                    },
                },
            },
        },
        yAxis: {
            categories: categories,
            title: {
                enabled: false,
            },
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
            gridLineColor: "transparent",
        },
        xAxis: {
            min: 0,
            lineColor: lineAndTextColor,
            tickColor: lineAndTextColor,
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
        },
        series: series,
    };
}

export function buildLastFieldSpotsConfig(lastFieldSpots, selectedField) {
    return {
        title: {
            text: `${lastFieldSpotsChartTitle} de ${selectedField}`,
            style: {
                color: lineAndTextColor,
            },
        },
        chart: {
            backgroundColor: backgroundColor,
            style: {
                color: lineAndTextColor,
            },
        },
        legend: {
            itemStyle: {
                color: lineAndTextColor,
            },
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true
                },
                enableMouseTracking: false,
                marker: {
                    radius: 3,
                    symbol: "circle",
                },
            },
        },
        yAxis: {
            title: {
                enabled: false,
            },
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
            gridLineColor: "transparent",
            reversed: true,
        },
        xAxis: {
            min: 0,
            lineColor: lineAndTextColor,
            tickColor: lineAndTextColor,
            labels: {
                style: {
                    color: lineAndTextColor,
                },
            },
            categories: Object.keys(lastFieldSpots),
        },
        series: [{
            name: "Último colocado",
            data: Object.values(lastFieldSpots)
        }],
    };
}

function getJitter(selectedField) {
    return selectedField === "Medicina Geral e Familiar" ? 0.1 : 0.05;
}

function getYears(fieldSpotsPerYear) {
    const years = [...Object.keys(fieldSpotsPerYear)].sort().reverse();
    years.unshift(0);
    return years
}

function getDistricts(fieldSpotsPerDistrict) {
    let districts = [];
    Object.keys(fieldSpotsPerDistrict).forEach(
        district => districts.unshift(getDistrictAbbreviation(district))
    )
    districts.unshift(0);
    return districts;
}

function toggleSeriesVisibility(clickedLegend) {
    var series = clickedLegend.chart.series;
    var otherSeriesAreHidden = false;
    series.forEach(function (item) {
        if (item != clickedLegend && !item.visible) {
            otherSeriesAreHidden = true;
        }
    }, clickedLegend);

    if (otherSeriesAreHidden) {
        series.forEach(function (item) {
            item.setVisible(true);
        }, clickedLegend);
    } else {
        series.forEach(function (item) {
            if (clickedLegend.index === item.index) {
                item.setVisible(true);
            } else {
                item.setVisible(false);
            }
        }, clickedLegend);
    }
}

function setYaxisForSwarmPlot(data, y) {
    let result = [];
    data.forEach((spot) => {
        result.push({
            x: spot.spot,
            y: y,
            institution: spot.institution
        });
    });
    return result;
}

function getDistrictPreposition(district) {
    switch (district) {
        case "Porto":
        case "Algarve":
        case "Alentejo":
            return "no";
        case "Guarda":
        case "Madeira":
            return "na";
        case "Açores":
            return "nos";
        default:
            return "em";
    }
}
